<template>
<div>
  <div class="row m-0 p-0">
    <div class="col-md-9 col-sm-6">
      Fecha notificación: {{notification.date}}
      <h5 class="pt-2">
      <span class ="circle-tag">N</span> {{newProcurementProjectString}}
      <router-link :to="{
          name: 'procurement',
          params: {
            id: notification.data.id
          }
        }">
          {{notification.data.title}}
      </router-link>
    </h5>
    </div>
    <div class="col-md-3 col-sm-6 text-right px-3" v-if="showActions">
      <div class="w-100">
        <template v-if="projectHasSubscription(notification.data.id)">
          <i v-b-tooltip.hover title="Quitar de favoritas" class="fas fa-star d-inline-block mb-2"  @click="deleteProjectSubscription(notification.data.id)"></i>
        </template>
        <template v-else>
          <template v-if="isNotResolved(notification.data)">
            <i v-b-tooltip.hover title="Añadir a favoritas" class="far fa-star d-inline-block mb-2"  @click="createProjectSubscription(notification.data.id)"></i>
          </template>
          <template v-else-if="isNotOutdated(notification.data)">
            <button class="btn btn-secondary mb-2" v-b-tooltip.hover :title="`Licitación ${ notification.data.status } Añadir a favoritos y avisarme cuando queden 6 meses de la finalización del período de ejecución`"  @click="createProjectSubscription(notification.data.id)">
              <i class="far fa-clock"></i> Avisar más adelante
            </button>
        </template>
        </template> 
      </div>
      <button class="btn btn-delete-confirm"   @click="updateNotification({processed: true, id: notification.id})">
        <i class ="fas fa-trash-alt ml-2"></i> Descartar
      </button>  
    </div>
  </div>
  <div class="row p-0 m-0">
    <ul class="pt-2">
      <li> <b> Importe total sin impuestos: </b> {{ formatAmount(notification.data.tax_exclusive_amount)}} </li>
      <li> <b> Lugar Ejecución: </b> {{ locationStr(notification.data.location) }}</li>
      <li>
        <b> Plazo de ejecución: </b>
        {{ plannedPeriod(notification.data.planned_period, notification.data.planned_period_unit) }}
      </li>
      <li> <b> Fecha límite presentación: </b> {{ date(notification.data.submission_deadline) }} </li>
      <li> <b> Órgano o entidad: </b>
        <router-link :to="{
          name: 'procurement_party',
          params: {
            id: notification.data.contracting_party.id
          }
        }">
          {{notification.data.contracting_party.name}}
        </router-link>
      </li>
      <li> <b> Por Lotes: </b> {{ notification.data.has_lots ? 'Sí' : 'No' }} </li>
      <li> <b> Estado: </b> {{ notification.data.status }} </li>
    </ul>
  </div>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import procurementMixin from '@/_mixins/procurement.mixin';

export default {
  name: 'projectNotification',
  props: {
    notification: {
      required: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [procurementMixin],
  computed: {
    newProcurementProjectString() {
      let str = 'Nueva licitación';
      if (this.notification.notification_types.includes('procurement_party_procurement_project_subscription')) {
        str += ' publicada por un órgano de contratación al que sigues';
      }
      str += ':';
      return str;
    },
  },
  methods: {
    ...mapActions('procurementNotificationsModule', {
      updateNotification: 'updateNotification',
    }),
  },
};
</script>

<style scoped>
ul{
  display:block;
}
button{
  width: 175px !important;
}
</style>
